/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/search': {
    width: 17,
    height: 16,
    viewBox: '0 0 17 16',
    data: '<path pid="0" _fill="#5E5E5E" fill-rule="evenodd" d="M12.5 11h-.79l-.28-.27A6.471 6.471 0 0013 6.5 6.5 6.5 0 106.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l3.507 3.5L16 14.507 12.5 11zM2 6.5C2 8.99 4.01 11 6.5 11S11 8.99 11 6.5 8.99 2 6.5 2 2 4.01 2 6.5z" clip-rule="evenodd"/>'
  }
})
